var React = require('react');

function Code (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8 0C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0H8ZM12.7352 22.632L14.6322 23.265L19.2652 9.36799L17.3682 8.73499L12.7352 22.632ZM11.0002 20.414L12.4142 19L9.41425 16L12.4142 13L11.0002 11.586L7.29325 15.293C6.90225 15.684 6.90225 16.316 7.29325 16.707L11.0002 20.414ZM24.7073 16.707L21.0002 20.414L19.5863 19L22.5863 16L19.5863 13L21.0002 11.586L24.7073 15.293C25.0983 15.684 25.0983 16.316 24.7073 16.707Z"}));
}

Code.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = Code;

Code.default = Code;
